var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PlaceholderBar from "@irati/ui/src/Placeholder";
import Flex from "@irati/ui/src/Flex";
import { IconCircle, Container, EmailHeaderLogo, HeaderSeparator } from "../styled";
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        var _a = this.props, showCustomLogo = _a.showCustomLogo, perkboxImageLink = _a.perkboxImageLink, customLogoLink = _a.customLogoLink;
        return (React.createElement(React.Fragment, null,
            React.createElement(PlaceholderBar, { type: "dark", margin: "0 0 30px 0", width: "50%" }),
            React.createElement(Flex, { margin: "0 0 30px 0" },
                React.createElement(IconCircle, null),
                React.createElement(Container, null,
                    React.createElement(Flex, { justifyContent: "space-between" },
                        React.createElement(Flex, null,
                            React.createElement(PlaceholderBar, { width: "50px" }),
                            React.createElement(PlaceholderBar, { width: "150px", margin: "0 0 0 5px" })),
                        React.createElement(PlaceholderBar, { width: "225px", margin: "0 0 0 5px" })),
                    React.createElement(PlaceholderBar, { width: "175px" }))),
            React.createElement(Flex, { justifyContent: "center", alignItems: "center", width: "90%", margin: "auto 0" },
                React.createElement(EmailHeaderLogo, { src: perkboxImageLink }),
                showCustomLogo && (React.createElement(React.Fragment, null,
                    React.createElement(HeaderSeparator, null),
                    React.createElement(EmailHeaderLogo, { src: customLogoLink }))))));
    };
    return Header;
}(PureComponent));
export default Header;
